module.exports = __webpack_public_path__ + "img/report.357b1cf3.png";